import EverTrue from 'app';
import _ from 'underscore';
import BaseRouter from 'base/base-router';
import LegacyCoreSearchController from 'apps/core-search/controllers/legacy-core-search-controller';
import InteractionDetailController from 'apps/interactions/controllers/interaction-detail-controller-wrapper';

const _is_hash_id = (params) => {
  return params && params.length === 32 && params.match(/^[a-zA-Z0-9]+$/);
};

class InteractionRouter extends BaseRouter {
  static initClass() {
    this.prototype.routes = {
      interaction: 'search',
      'interaction/search/:hash_id': 'search',
      'interaction/:id': 'interaction',
    };
  }

  search(params) {
    EverTrue.execute('removePageContainer');
    EverTrue.execute('setBrowserTitle', 'Interactions');

    let hash_id;
    if (_is_hash_id(params)) {
      hash_id = params;
      EverTrue.track.setReferrer('shared_search');
    }

    this.currentView = <LegacyCoreSearchController type="interactions" hash_id={hash_id} />;
    EverTrue.page.mount(this.currentView);
  }

  interaction(id) {
    this.currentView = <InteractionDetailController id={_.toNumber(id)} />;
    EverTrue.page.mount(this.currentView);
  }
}

InteractionRouter.initClass();
export default InteractionRouter;
